"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchToastIcon = void 0;
var react_1 = __importDefault(require("react"));
var Icons_1 = require("@amzn/atoz-web/Icons");
var PunchToastModalTypes_1 = require("../PunchToastModal/PunchToastModalTypes");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var PunchToastIcon = function (_a) {
    var status = _a.status;
    var iconStyle = {
        transform: 'scale(2)',
        marginBottom: 20
    };
    if (status === PunchToastModalTypes_1.PunchToastModalStatus.error) {
        return (react_1.default.createElement("div", { style: iconStyle },
            react_1.default.createElement(Icons_1.IconCloseCircleFill, { color: "red80", size: Icons_1.IconSize.Large, dataTestId: "icon-close-circle-fill" })));
    }
    else {
        return (react_1.default.createElement("div", { style: iconStyle },
            react_1.default.createElement(Icons_1.IconCheckCircleFill, { color: "green70", size: Icons_1.IconSize.Large, dataTestId: "icon-check-circle-fill" })));
    }
};
exports.PunchToastIcon = PunchToastIcon;
